import React, { useState } from 'react';
import PropTypes from 'prop-types';

function Password({ callback }) 
{
  const [password, setPassword] = useState(null);

  const onChange = (e) => {
    setPassword(e.target.value);
  }
  const onEnterPress = (e) => {
    if (e.charCode === 13 && password === 'ns6yT9jb') {
      callback();
    }
  }

  return (
    <div className='flexColumn' style={{gap:8}}>
      <span>Password</span>
      <input type="text" onKeyPress={onEnterPress} onChange={onChange} />
    </div>
  )
}

Password.propTypes = {
  callback: PropTypes.func.isRequired,
}

export default Password;
